var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-ish',_vm._l((_vm.applications),function(application){return _c('table-ish-row-router-link',{key:application.uuid,attrs:{"to":{
            name: _vm.$router.fix('dashboard.*.applications.show'),
            params: {
                application: application.uuid
            }
        }}},[_c('table-ish-cell',[_vm._t("primary",null,{"application":application}),_vm._v(" "),_c('template',{slot:"secondary"},[_vm._t("secondary",null,{"application":application})],2)],2)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }